import BrandIntro from './components/BrandIntro';
import Reputation from './components/Reputation';
import ContactSection from './components/ContactSection';

export default function AboutPage() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '91n官方',
    url: 'https://91n.com/',
    description: '91n是您值得信赖的内容平台，提供91n最新入口、91n官方地址及91n使用指南。',
    contactPoint: {
      '@type': 'ContactPoint',
      contactType: 'customer service',
      email: 'support@91n.com',
      availableLanguage: ['Chinese'],
    },
  };

  return (
    <main className="min-h-screen pt-16">
      <script type="application/ld+json">
        {JSON.stringify(orgSchema)}
      </script>

      <div className="bg-background-100 py-16 md:py-20">
        <div className="w-full max-w-6xl mx-auto px-4 md:px-6 text-center">
          <h2 className="text-3xl md:text-4xl font-bold font-serif text-foreground-900 mb-4">
            关于我们
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            了解91n官方入口导航站的故事与愿景
          </p>
          <div className="flex items-center justify-center gap-2 mt-3 text-xs text-foreground-400">
            <span>品牌介绍</span>
            <span>·</span>
            <span>用户口碑</span>
            <span>·</span>
            <a href="#contact" className="text-primary-500 hover:text-primary-600 cursor-pointer">联系我们</a>
          </div>
        </div>
      </div>

      <BrandIntro />
      <Reputation />
      <ContactSection />
    </main>
  );
}